import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Button } from 'base-ui'

export const ProductPageOdsDialogServiceLinkButton: FC<{
  href: string
}> = ({ href }) => (
  <Button<'a'>
    className="mt-5 w-full"
    data-qa-id="form-ods-modal-go-to-online-doctor"
    href={href}
    slots={{ root: 'a' }}
    target="_blank"
  >
    <FormattedMessage id="pdp.buyboxwithvariants.odsModal.button.accesstomedication" />
  </Button>
)
